export const LicenseItemCounts = {
    FEEDING_SCHEDULE_BASIC: 5,
    FEEDING_SCHEDULE_EXTENDED: 15,
    FEEDING_CURVE_BASIC: 5,
    FEEDING_CURVE_EXTENDED: 15,
    FEEDING_FORAGE_BASIC: 2,
    FEEDING_FORAGE_EXTENDED: 8
};